import qs from 'qs';
import options from './options';
import { isServer } from './isServer';

// Parses a URL search string into the searchState shape react-instantsearch
// expects. Kept free of any `window` access so the server can derive exactly
// the same value the browser will — see the note on getInitData below.
export function parseSearchState(search) {
  const initData = qs.parse(String(search || '').replace(/^\?/, ''));
  if (initData.toggle) {
    if (initData.toggle.adaCompliant === 'true') {
      initData.toggle.adaCompliant = true;
    } else {
      // connectToggle reads this as "off" whether it is absent or undefined;
      // dropping it keeps the state JSON-serialisable, which getServerSideProps
      // requires of anything it returns as props.
      delete initData.toggle.adaCompliant;
    }
  }
  return initData;
}

// Server-side counterpart to getInitData(). `resolvedUrl` comes from the
// getServerSideProps context and still carries the query string.
export function initialSearchStateFromUrl(resolvedUrl) {
  const url = String(resolvedUrl || '');
  const queryStart = url.indexOf('?');
  return parseSearchState(queryStart === -1 ? '' : url.slice(queryStart));
}

// Browser-side initial searchState.
//
// This diverging from the server was the root cause of TSD-5063: a page that
// seeded InstantSearch straight from here rendered unfiltered results on the
// server and filtered results on hydration, and the resulting React 18
// recoverable error tripped a crash in Next 13.1.1's onRecoverableError. Pages
// that care about SSR correctness should resolve the state with
// initialSearchStateFromUrl() in getServerSideProps and pass it down instead of
// letting the view call this during render.
export function getInitData() {
  if (!isServer) {
    return parseSearchState(window.location.search);
  }
  return false;
}
export function setUrl(searchState) {
  if (!isServer) {
    const search = searchState
      ? `${window.location.pathname}?${qs.stringify(searchState)}`
      : '';
    window.history.pushState(searchState, null, search);
  }
  return;
}

export function getDefaultPath() {
  const getParent = (lastRoute) => {
    const parent = [];
    if (!lastRoute) return parent;
    parent.push(lastRoute);
    options.forEach((option) => {
      if (option.children) {
        option.children.forEach((child) => {
          if (child.key === lastRoute) {
            parent.push(option.key);
          }
        });
      }
    });
    return parent;
  };
  if (!isServer && window.location.pathname) {
    const routes = window.location.pathname.split('/');
    if (routes.length > 1) {
      const lastRoute = routes[routes.length - 1];
      return getParent(lastRoute);
    }
  }
  return [];
}
